export default __webpack_public_path__ + "static/media/codes.4249978a.csv";